import styled from "styled-components";
import { tokens } from "../../../../public/tokens";

/*
 * Background/text color pairs for the campus badge, keyed by lowercased
 * campus name. Shared by LinkedProgrammesTable and ModuleReadinessPopover,
 * which both render the same badge.
 */
const campusTones = {
    online: {
        background: tokens.colors.brand.naartjie["100"],
        color: tokens.colors.brand.naartjie["600"],
    },
    midrand: {
        background: tokens.colors.brand["tide-blue"]["100"],
        color: tokens.colors.brand["tide-blue"]["700"],
    },
    "cape town": {
        background: tokens.colors.brand["veld-sprout"]["100"],
        color: tokens.colors.brand["veld-sprout"]["700"],
    },
};

export const StyledCampusBadge = styled.span(({ $campus }) => {
    const key = String($campus || "")
        .trim()
        .toLowerCase();

    const tone = campusTones[key] || {
        background: tokens.colors.neutral.grey["100"],
        color: tokens.colors.text.secondary,
    };

    return {
        minHeight: "18px",
        maxHeight: "18px",

        padding: `${tokens.globals["spacing-1"]} ${tokens.globals["spacing-2"]}`,

        borderRadius: "10px",

        background: tone.background,
        color: tone.color,

        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        fontFamily: tokens.typography.fontFamilies["albert-sans"],
        fontSize: tokens.typography.fontSize["sm-10px"],
        fontWeight: tokens.typography.fontWeights.semibold,

        lineHeight: 1,

        whiteSpace: "nowrap",
    };
});

/*
 * Programme name + campus/method meta cluster, shared by LinkedProgrammesTable's
 * row and ModuleReadinessPopover's header — both render the same identity block.
 */
export const StyledProgrammeDetails = styled.div({
    minWidth: 0,

    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",

    gap: tokens.globals["spacing-1"],
});

export const StyledProgrammeName = styled.span(({ $maxWidth = "100%" }) => ({
    maxWidth: $maxWidth,

    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",

    color: tokens.colors.text.primary,

    fontSize: tokens.typography.fontSize["lg-14px"],
    fontWeight: tokens.typography.fontWeights.semibold,
    lineHeight: 1.1,
}));

export const StyledProgrammeMetaRow = styled.div({
    display: "flex",
    alignItems: "center",

    gap: tokens.globals["spacing-1-5"],

    minWidth: 0,

    flexWrap: "wrap",
});

export const StyledMethod = styled.span({
    minWidth: 0,

    display: "inline-flex",
    alignItems: "center",

    gap: tokens.globals["spacing-1"],

    color: tokens.colors.text.secondary,

    fontSize: tokens.typography.fontSize["sm-10px"],
    fontWeight: tokens.typography.fontWeights.regular,
    lineHeight: 1,

    whiteSpace: "nowrap",

    i: {
        fontSize: "10px",
    },
});

